import { render, staticRenderFns } from "./wl.vue?vue&type=template&id=0c2f0858&scoped=true&"
import script from "./wl.vue?vue&type=script&lang=js&"
export * from "./wl.vue?vue&type=script&lang=js&"
import style0 from "./wl.vue?vue&type=style&index=0&id=0c2f0858&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2f0858",
  null
  
)

export default component.exports